var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draggble-window"},[_c('div',{staticClass:"draggble-window__content",on:{"mousedown":function($event){return _vm.onMove($event, _vm.$el)}}},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }